<template>
  <div>
    <nav-bar :title="'Notifications'"></nav-bar>
    <notification-modal-clear-confirm
      :closeOrShow="showModalConfirmClearNotifications"
      :removeAll="removeAll"
      :closeModal="closeModalNotificationClear"
    ></notification-modal-clear-confirm>
    <b-container class="mb-5 mobile p-4 layout-tasks">
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <notifications-skeleton></notifications-skeleton>
        </template>
        <section v-if="!notifications.length" class="d-block text-center">
          <span class="material-icons full-icon align-middle mt-2 mb-2">notifications</span>
          <p class="text-muted mx-5 text-wrap">
            You don't have any notification yet.
          </p>
        </section>

        <section v-else>
          <div class="d-block my-3">
            <div class="text-right">
              <b-link @click="clearNotifications()">Clear all notifications</b-link>
            </div>
            <b-list-group class="mt-3 mb-5">
              <div v-for="item in notifications" :key="item.id">
                <notification-collapse-group
                  :isParent="userIsAParent"
                  :visible="true"
                  :notification="item"
                  @onReadNotification="readNotification"
                  @onAcceptItem="handleAcceptingItem"
                  @onRejectItem="handleAcceptingItem"
                >
                </notification-collapse-group>
              </div>
            </b-list-group>
          </div>
        </section>
      </b-skeleton-wrapper>
    </b-container>
  </div>
</template>

<script>
import { NavBar } from '@/common/components';
import { useSessionStore, useNotificationStore } from '@/common';
import { getNotifications, markAllNotificationAsRead } from '../services';
import notificationsActionMixin from '../mixins/notificationsAction.mixin';
import { NotificationCollapseGroup, NotificationModalClearConfirm } from '../components';
import NotificationsSkeleton from '@/notifications/components/skeletons/NotificationsSkeleton';

export default {
  components: {
    NotificationsSkeleton,
    NotificationCollapseGroup,
    NotificationModalClearConfirm,
    NavBar,
  },
  mixins: [notificationsActionMixin],
  data() {
    const sessionStore = useSessionStore();
    const notificationStore = useNotificationStore();
    return {
      loading: false,
      notifications: [],
      sessionStore,
      notificationStore,
      showModalConfirmClearNotifications: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      const { notifications = [], total = 0 } = await getNotifications(
        this.childId,
        this.userIsAParent,
      );
      this.notifications = notifications;
      this.notificationStore.updateTotal(total);
    } catch (error) {
      console.error('Error: Problem when try load the notifications', error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    removeAll() {
      const childId = this.childId;
      markAllNotificationAsRead({ childId });
      this.notificationStore.updateTotal(0);
      this.$router.push('/');
    },
    clearNotifications() {
      const noTasksToApproved = this.validationOfTasksToBeApproved();
      if (noTasksToApproved) this.removeAll();
    },
    validationOfTasksToBeApproved() {
      const currentNotifications = this.notifications;
      const thereAreUnapprovedTasks = currentNotifications.map((notification) => {
        return notification.types[0].notifications.every((notification) => notification.actions);
      });
      if (thereAreUnapprovedTasks.includes(true)) {
        this.openModalNotificationClear();
        return false;
      }
      return true;
    },
    openModalNotificationClear() {
      this.showModalConfirmClearNotifications = true;
    },
    closeModalNotificationClear() {
      this.showModalConfirmClearNotifications = false;
    },
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    childId() {
      return `${this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId}`;
    },
  },
};
</script>
